<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-card-text>
          <v-container fluid grid-list-lg class="pt-0">
            <v-layout row wrap>
              <v-flex xs12 md4 sm6>
                <v-menu :close-on-content-click="false" :nudge-width="400" v-model="expandedView" offset-y full-width
                  max-height="470px">
                  <v-text-field slot="activator" v-model="selectedValues" :label="messages.label.SEARCH_CRITERIA"
                    readonly></v-text-field>
                  <v-card>
                    <v-layout row wrap>
                      <v-flex xs5 md5 sm5 class="pa-2">
                        <v-card>
                          <v-card-title>
                            <v-textarea v-model="rawText" @blur="computeText()" rows="18" full-width hide-details>
                            </v-textarea>
                          </v-card-title>
                        </v-card>
                      </v-flex>
                      <v-flex xs7 md7 sm7 class="pa-2">
                        <v-card class="scroll">
                          <v-list subheader>
                            <v-subheader v-if="validHouseIds.length > 0">House ID
                              <v-spacer></v-spacer>
                              <v-btn color="primary" flat @click="addNewHouseId()">
                                <v-icon left>add_circle</v-icon>
                                <span>Add House Id</span>
                              </v-btn>
                            </v-subheader>
                            <template v-for="(item, index) in validHouseIds">
                              <v-list-tile :key="index">
                                <v-list-tile-action>
                                  <v-checkbox color="primary" v-model="item.selected"></v-checkbox>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                  <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>
                            </template>
                            <v-list-tile v-if="newHouseIdTemplate">
                              <v-list-tile-action>
                                <v-checkbox color="primary" v-model="newHouseIdSelected"
                                  @change="removeNewTextField(newHouseIdSelected)">
                                </v-checkbox>
                              </v-list-tile-action>
                              <v-text-field class="mt-3 mr-2" v-model="newHouseIdValue"
                                :label="messages.label.HOUSE_ID"></v-text-field>
                              <v-list-tile-action>
                                <v-btn-toggle mandatory v-model="isOrContains">
                                  <v-btn flat value="IS">
                                    {{ messages.label.IS }}
                                  </v-btn>
                                  <v-btn flat value="CONTAINS">
                                    {{ messages.label.CONTAINS }}
                                  </v-btn>
                                </v-btn-toggle>
                              </v-list-tile-action>
                            </v-list-tile>
                          </v-list>
                          <v-list subheader>
                            <v-subheader v-if="validPackageIDs.length > 0">Package ID</v-subheader>
                            <template v-for="(item, index) in validPackageIDs">
                              <v-list-tile :key="index">
                                <v-list-tile-action>
                                  <v-checkbox color="primary" v-model="item.selected"></v-checkbox>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                  <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>
                            </template>
                          </v-list>
                          <v-list subheader>
                            <v-subheader v-if="validFileNames.length > 0">File Names</v-subheader>
                            <template v-for="(item, index) in validFileNames">
                              <v-list-tile :key="index">
                                <v-list-tile-action>
                                  <v-checkbox color="primary" v-model="item.selected"></v-checkbox>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                  <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                                </v-list-tile-content>
                              </v-list-tile>
                            </template>
                          </v-list>
                        </v-card>
                      </v-flex>
                    </v-layout>
                    <v-card-actions>
                      <v-btn flat @click="clearTextArea()" color="error">{{ messages.label.CLEAR }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-flex>
              <v-flex md2 sm3>
                <v-combobox v-model="selectedProvider" :label="messages.label.PROVIDER_NAME" multiple tags
                  item-text="name" item-value="name" :items="providersList"></v-combobox>
              </v-flex>
              <v-flex md2 sm3>
                <v-menu ref="startDateMenu" lazy :close-on-content-click="false" v-model="startDateMenu"
                  transition="scale-transition" offset-y full-width :nudge-right="40" max-width="290px"
                  min-width="290px">
                  <v-text-field slot="activator" :label="messages.label.START_DATE" v-model="startDate"
                    prepend-icon="event" readonly>
                  </v-text-field>
                  <v-date-picker v-model="startDate" :max="maxStartDate" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="clearStartDate()">{{ messages.label.CANCEL }}</v-btn>
                    <v-btn flat color="primary" @click="$refs.startDateMenu.save(startDate)">{{ messages.label.OK }}
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex md2 sm3>
                <v-menu ref="endDateMenu" lazy :close-on-content-click="false" v-model="endDateMenu"
                  transition="scale-transition" offset-y full-width :nudge-right="40" max-width="290px"
                  min-width="290px">
                  <v-text-field slot="activator" :label="messages.label.END_DATE" v-model="endDate" prepend-icon="event"
                    readonly></v-text-field>
                  <v-date-picker v-model="endDate" :min="minEndDate" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="clearEndDate()">{{ messages.label.CANCEL }}</v-btn>
                    <v-btn flat color="primary" @click="$refs.endDateMenu.save(endDate)">{{ messages.label.OK }}</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 md2>
                <v-btn color="primary" @click="searchAssets()">{{ messages.label.SEARCH }}</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import messages from "@/AssetStatus/messages.json"
import AssetStatusService from "@/AssetStatus/AssetStatusService"

export default {
  name: "AssetStatusSearchFilter",
  data() {
    return {
      expandedView: false,
      rawText: "",
      validPackageIDs: [],
      validHouseIds: [],
      validFileNames: [],
      newHouseIdTemplate: false,
      newHouseIdSelected: true,
      newHouseIdValue: "",
      isOrContains: "IS",
      selectedValues: "",
      selectedProvider: "",
      providersList: this.retrieveProviders(),
      startDate: null,
      endDate: null,
      startDateMenu: false,
      endDateMenu: false
    }
  },
  watch: {
    expandedView: function (value) {
      let selectedValuesArray = []
      if (!value && !this.$lodash.isEmpty(this.rawText)) {
        this.$lodash.forEach(this.validHouseIds, (item) => {
          if (item.selected) {
            selectedValuesArray.push(item.name)
          }
        })
        this.$lodash.forEach(this.validPackageIDs, (item) => {
          if (item.selected) {
            selectedValuesArray.push(item.name)
          }
        })
        this.$lodash.forEach(this.validFileNames, (item) => {
          if (item.selected) {
            selectedValuesArray.push(item.name)
          }
        })
        this.selectedValues = selectedValuesArray.join(",")
      } else {
        this.selectedValues = ""
      }
    }
  },
  methods: {
    clearStartDate() {
      this.startDate = null
    },
    clearEndDate() {
      this.endDate = null
    },
    retrieveProviders() {
      return [
        {
          id: 1,
          name: "Provider1"
        },
        {
          id: 2,
          name: "Provider2"
        }
      ]
    },
    addNewHouseId() {
      this.newHouseIdSelected = true
      this.newHouseIdValue = ""
      this.isOrContains = "IS"
      this.newHouseIdTemplate = true
    },
    clearTextArea() {
      this.rawText = ""
      this.computeText()
    },
    computeText() {
      this.validPackageIDs = []
      this.validHouseIds = []
      this.validFileNames = []
      if (!this.$lodash.isEmpty(this.rawText)) {
        let packageIdRegEx = /[A-Z]{4}[0-9]{16}/gi
        let packageIdArray = this.rawText.match(packageIdRegEx)
        this.$lodash.forEach(packageIdArray, (value) => {
          this.validPackageIDs.push({
            name: value,
            selected: true
          })
        })
        let houseIdRegEx = /([\w\d_-]*)\.?_[A-Z]{4}[0-9]*/gi
        let houseIdArray = this.rawText.match(houseIdRegEx)
        this.$lodash.forEach(houseIdArray, (value) => {
          this.validHouseIds.push({
            name: value,
            selected: true
          })
        })
        let fileNameRegEx = /([\w\d_-]*)\.?(\.\w+)/gi
        let fileNamesArray = this.rawText.match(fileNameRegEx)
        this.$lodash.forEach(fileNamesArray, (value) => {
          this.validFileNames.push({
            name: value,
            selected: true
          })
        })
      }
    },
    removeNewTextField(newHouseIdSelected) {
      if (!newHouseIdSelected && this.newHouseIdTemplate) {
        this.newHouseIdTemplate = false
      }
    },
    searchAssets() {
      AssetStatusService.$emit("event:AssetStatusSerach")
    }
  },
  computed: {
    maxStartDate() {
      return this.endDate
    },
    minEndDate() {
      return this.startDate
    }
  },
  created() {
    this.messages = messages
  }
}
</script>
<style scoped>
.scroll {
  height: 395px;
  overflow-y: scroll;
  display: block;
}

.scroll::-webkit-scrollbar {
  -webkit-appearance: none;
}

.scroll::-webkit-scrollbar:vertical {
  width: 11px;
}

.scroll::-webkit-scrollbar:horizontal {
  height: 11px;
}

.scroll::-webkit-scrollbar-thumb {
  border-radius: 8px;
  border: 2px solid white;
  /* should match background, can't be transparent */
  background-color: rgba(0, 0, 0, 0.5);
}

.scroll::-webkit-scrollbar-track {
  background-color: #fff;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/AssetStatus/AssetStatusSearchFilter.vue